import { getUserPhotoURL } from 'utils';

import { actions } from './actions';

const INITIAL_STATE = {
  user: {},
  loading: false,
  error: {},
  isPasswordResetEmailSent: false,
  isPasswordChanged: false,
  notifications: {
    loading: true,
    all: [],
  },
  forgotPassword: {
    passwordSent: false,
    error: '',
  },
  userActions: {
    passwordResetEmail: null,
    passwordResetSuccess: false,
    error: null,
  },
  feedback: {
    sent: false,
    errors: null,
  },
  signup: {
    error: {},
  },
  reauth: false,
  integrations: [],
  subscriptions: [],
  billing: null,
};

export default function userReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case actions.SIGN_IN_SUCCESS:
    case actions.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
          ...(payload.photoURL
            ? { photoURL: getUserPhotoURL(payload.photoURL, false) }
            : {}),
        },
      };
    case actions.SIGN_OUT_SUCCESS:
      return INITIAL_STATE;
    case actions.TOGGLE_LOADING:
      return { ...state, loading: payload };
    case actions.SHOW_ERROR:
      return { ...state, error: payload };
    case actions.HIDE_ERROR:
      return { ...state, error: {} };
    case actions.RESET_PASSWORD_EMAIL_SUCCESS:
      return { ...state, isPasswordResetEmailSent: payload };
    case actions.CHANGE_PASSWORD_SUCCESS:
      return { ...state, isPasswordChanged: payload };
    case actions.NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: { ...state.notifications, all: payload },
      };
    case actions.TOGGLE_NOTIFICATIONS_LOADING:
      return {
        ...state,
        notifications: { ...state.notifications, loading: payload },
      };
    case actions.FORGOT_PASSWORD_UPDATE:
      return { ...state, forgotPassword: payload };
    case actions.USER_ACTION_UPDATE:
      return { ...state, userActions: payload };
    case actions.FEEDBACK_UPDATE:
      return { ...state, feedback: payload };
    case actions.SIGNUP_UPDATE:
      return { ...state, signup: payload };
    case actions.TOGGLE_REAUTH:
      return { ...state, reauth: !state.reauth };
    case actions.SUBSCRIPTIONS_SUCCESS:
      return { ...state, subscriptions: payload };
    case actions.BILLING_DETAILS_SUCCESS:
      return { ...state, billing: payload };
    case actions.FETCH_CURRENT_INTEGRATIONS_SUCCESS:
      return { ...state, integrations: payload };
    default:
      return state;
  }
}
